import { render, staticRenderFns } from "./TicketMsg.vue?vue&type=template&id=2a9dfce6&scoped=true&"
import script from "./TicketMsg.vue?vue&type=script&lang=js&"
export * from "./TicketMsg.vue?vue&type=script&lang=js&"
import style0 from "./TicketMsg.vue?vue&type=style&index=0&id=2a9dfce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9dfce6",
  null
  
)

export default component.exports